
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-my-password",
      function () {
        return require("private-next-pages/forgot-my-password.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgot-my-password"])
      });
    }
  